import { useTheme } from '@shopify/restyle';

import type { PressableProps } from 'react-native';
import { Pressable } from 'react-native';
import type { Theme } from 'app/shopify';
import { IconPencil } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';

export function EditButton(props: Pick<PressableProps, 'onPress'>) {
  const theme = useTheme<Theme>();

  return (
    <Pressable
      {...props}
      style={{
        alignItems: 'center',
        aspectRatio: 1,
        backgroundColor: theme.colors['surface.secondary-neutral'],
        borderRadius: theme.borderRadii['radius.lg'],
        height: 30,
        justifyContent: 'center',
      }}
    >
      <IconPencil strokeWidth={ICON_STROKE_WIDTH} size={20} />
    </Pressable>
  );
}
